import { combineReducers } from 'redux';

import { initializable } from '../../utils/editor';
import { EDITOR_NAME } from '../connect-editor';
import opportunity from './opportunity';
import productsById from './products-by-id';
import quote from './quote';
import quoteLineFilters from './quote-line-filters';
import quoteLinesById from './quote-lines-by-id';
import quoteLinesSelection from './quote-lines-selection';
import quoteUI from './quote-ui';
import savedQuote from './saved-quote';

export default initializable(
  EDITOR_NAME,
  combineReducers({
    opportunity,
    productsById,
    quote,
    quoteLinesById,
    quoteLinesSelection,
    quoteLineFilters,
    quoteUI,
    savedQuote,
  }),
);
